export interface ArticleDetails {
  citation_url?: string;
  url?: string;
  doi?: string;
  publisher?: string;
  access_level?: string;
}

/** Preserve the server's exact passage fragment, including percent encoding. */
export function articleReferenceUrl(details?: ArticleDetails): string | undefined {
  for (const value of [details?.citation_url, details?.url]) {
    if (!value) continue;
    try {
      const url = new URL(value);
      if (url.protocol === "https:" && url.hostname && !url.username && !url.password) return value;
    } catch { /* Try the canonical URL or legacy DOI. */ }
  }
  const doi = details?.doi?.trim().replace(/^https?:\/\/(?:dx\.)?doi\.org\//i, "");
  return doi && /^10\.\d{4,9}\/\S+$/.test(doi)
    ? `https://doi.org/${doi}` : undefined;
}
